import React from "react";
import { Button, makeStyles, Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import { quoteFooterStyles } from "features/quote/styles";
import { useTranslation } from "react-i18next";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { ArrowBack, Check } from "@material-ui/icons";
import { LIST_QUOTE_ITEM_QUERY } from "features/quotes/queries";

const useStyles = makeStyles(quoteFooterStyles);

function QuoteFooter({
  btnBackLabel,
  btnNextLabel,
  btnBackIcon,
  btnNextIcon,
  handleBack,
  handleComplete,
  btnBackDisabled,
  btnNextDisabled,
  btnBackExists,
  btnNextExists,
  quoteId,
}) {
  const { t } = useTranslation();
  const quoteExists = Boolean(quoteId);

  const { data, loading } = useQueryWithErrorHandling(LIST_QUOTE_ITEM_QUERY, {
    variables: { quoteId },
    skip: !quoteExists,
  });
  const listQuoteItem = data?.listQuoteItem;

  const classes = useStyles({ listQuoteItem });

  return (
    <Grid container alignItems="center">
      <Grid
        item
        container
        xs={12}
        justifyContent="space-between"
        alignItems="center"
        className={classes.footerActionsBar}
      >
        <>
          <Grid item>
            {btnBackExists && !loading && (
              <Button
                variant="contained"
                color="primary"
                disabled={btnBackDisabled}
                onClick={handleBack}
                className={classes.footerButton}
                endIcon={btnBackIcon || <ArrowBack />}
              >
                {btnBackLabel || t("General.Back")}
              </Button>
            )}
          </Grid>

          <Grid item>
            {btnNextExists && !loading && (
              <Button
                variant="contained"
                color="primary"
                disabled={btnNextDisabled}
                onClick={handleComplete}
                className={classes.footerButton}
                endIcon={btnNextIcon || <Check />}
              >
                {btnNextLabel || t("General.Save")}
              </Button>
            )}
          </Grid>
        </>
      </Grid>
      <Grid
        item
        container
        xs={12}
        alignItems="center"
        justifyContent="space-between"
        className={classes.footerStatusBar}
      >
        <Grid item>
          {t("Quote.TransactionId")}: {listQuoteItem?.quote?.transactionId || "-"}
        </Grid>
        <Grid item>
          {listQuoteItem?.oldActionName}: {listQuoteItem?.lastActionAgo}
        </Grid>
        <Grid item>
          {t("Quote.Status")}: {listQuoteItem?.quote?.quoteStatusName || "-"}
        </Grid>
      </Grid>
    </Grid>
  );
}

QuoteFooter.defaultProps = {
  btnNextExists: true,
  btnBackExists: true,
};

QuoteFooter.propTypes = {
  btnBackLabel: PropTypes.string,
  btnNextLabel: PropTypes.string,
  btnBackIcon: PropTypes.node,
  btnNextIcon: PropTypes.node,
  handleBack: PropTypes.func.isRequired,
  handleComplete: PropTypes.func.isRequired,
  btnBackDisabled: PropTypes.bool.isRequired,
  btnNextDisabled: PropTypes.bool.isRequired,
  btnNextExists: PropTypes.bool,
  btnBackExists: PropTypes.bool,
  quoteId: PropTypes.number,
};

export default QuoteFooter;
